/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type appSageIntacct_viewer$ref = any;
export type appSageIntacct_QueryVariables = {||};
export type appSageIntacct_QueryResponse = {|
  +viewer: ?{|
    +actualPersonId: ?string,
    +component: ?string,
    +$fragmentRefs: appSageIntacct_viewer$ref,
  |}
|};
export type appSageIntacct_Query = {|
  variables: appSageIntacct_QueryVariables,
  response: appSageIntacct_QueryResponse,
|};
*/


/*
query appSageIntacct_Query {
  viewer {
    actualPersonId
    component(name: "app_sage_intacct")
    ...appSageIntacct_viewer
    id
  }
}

fragment appSageIntacct_viewer on Viewer {
  id
  company {
    id
    sageIntacctEnabled
    workatoCustomerId
    workatoForecastSageIntacctConnectionId
    workatoSageIntacctConnectionId
    workatoIframeToken
    sageIntacctTimeRegsFromForecast
    sageIntacctSyncOnlyApproved
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "app_sage_intacct"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"app_sage_intacct\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "appSageIntacct_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "appSageIntacct_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "appSageIntacct_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sageIntacctEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "workatoCustomerId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "workatoForecastSageIntacctConnectionId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "workatoSageIntacctConnectionId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "workatoIframeToken",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sageIntacctTimeRegsFromForecast",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sageIntacctSyncOnlyApproved",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "appSageIntacct_Query",
    "operationKind": "query",
    "text": "query appSageIntacct_Query {\n  viewer {\n    actualPersonId\n    component(name: \"app_sage_intacct\")\n    ...appSageIntacct_viewer\n    id\n  }\n}\n\nfragment appSageIntacct_viewer on Viewer {\n  id\n  company {\n    id\n    sageIntacctEnabled\n    workatoCustomerId\n    workatoForecastSageIntacctConnectionId\n    workatoSageIntacctConnectionId\n    workatoIframeToken\n    sageIntacctTimeRegsFromForecast\n    sageIntacctSyncOnlyApproved\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e06d818b6ab13df315524e1e3a36242b';

module.exports = node;
